module.exports = __webpack_public_path__ + "static/simcrest-apps-time-and-billing-1eaa1818c44b4a2d7e18a528cbfc4cd3.png";